// src/components/CustomLink.tsx

import { Link } from 'react-router-dom';
import React from 'react';

// Explicitly cast Link to a Function Component
const CustomLink = Link as React.FC<any>;

export default CustomLink;
